import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function KompositlaagePage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/pxl-20260619-125952937-mp.jpg", title: "Bred komposit dobbeltlåge ved brosten" },
    { src: "/_assets/480015480-1282476033240594-6954968780598279616-n.jpg", title: "kompositlåge" },
    { src: "/_assets/472310234-1121723912661396-3762314424514631135-n.jpg", title: "kompositlåge i Danmark" },
    { src: "/_assets/472038870-1118953512938436-7608909420930405236-n.jpg", title: "kompositlåge med håndtag" },
    { src: "/_assets/331549583-1582118552290587-2785698352397863311-n.jpg", title: "kompositlåge i haven" },
    { src: "/_assets/299939634-600610274772765-4419569559744351444-n.jpg", title: "kompositlåge og hegn" },
    { src: "/_assets/1000003614.jpg", title: "kompositlåge ved hus" },
    { src: "/_assets/thumbnail-1000003003.jpg", title: "lav kompositlåge" },
    { src: "/_assets/thumbnail-1000003390.jpg", title: "kompositlåge i Odense" },
    { src: "/_assets/thumbnail-1000003442.jpg", title: "kompositlåge afskærmning" },
    { src: "/_assets/thumbnail-img20241015151127.jpg", title: "stor kompositlåge" },
    { src: "/_assets/thumbnail-img20241122121947.jpg", title: "bred kompositlåge" },
    { src: "/_assets/thumbnail-img20250825122425.jpg", title: "sort kompositlåge" },
    { src: "/_assets/316801948-679177383570465-3757897963065229175-n.jpg", title: "kompositlåge i Gentofte" },
    { src: "/_assets/thumbnail-1000003446.jpg", title: "kompositlåge i Silkeborg" },
    { src: "/_assets/thumbnail-1000004103.jpg", title: "Kompositlåge i Aalborg" },
  ];

  return (
    <>
      <SEO
        title="Kompositlåge | 100% kvalitet i hele Danmark | Kontakt os"
        description="Med en kompositlåge fra Hovendals, er lågen altid lavet i tæt dialog med dig, så du er tilfreds med resultatet. Ring og høre mere i dag."
        ogImage="/_assets/487081567-1316237406531123-7184057925719061233-n.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/487081567-1316237406531123-7184057925719061233-n.jpg", "width=1600,quality=80,format=auto")}
            alt="Kompositlåge"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-door-closed" aria-hidden="true"></i>
              <span>Vedligeholdelsesfri</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Kompositlåger – vedligeholdelsesfri og funktionelle
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Kompositlågen er til dig, der ønsker en vedligeholdelsesfri havelåge i holdbart design.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Fleksibel & praktisk</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Låger i komposit – fleksible og praktiske
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Kompositlågen er til dig, der ønsker en vedligeholdelsesfri havelåge. Lågen kan både bruges i forbindelse med en hæk, et <Link to="/komposithegn" className="text-[#004fa4] font-bold hover:underline">komposithegn</Link> eller andre hegn, hvor en låge kan sættes imellem. Lågen kan sættes, så den ikke behøver være i forlængelse af andet hegn, som det eksempelvis kan ses på billederne nedenfor.
              </p>

              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  Få skræddersyet kompositlåger til dine mål og ønsker
                </h3>
                <p className="text-slate-700 leading-relaxed text-base">
                  Fælles for begge løsninger er, at du hos Hovendals kan få speciallavet din kompositlåge, så den passer både i højden og længden. Det er selvfølgelig også muligt at købe en komposit-havelåge, der er lavet efter standardmål. Derudover kan du selv vælge farve og struktur på din låge, så den for eksempel kan minde så meget om træ som muligt eller omvendt. Uanset hvad du vælger, så kan vi hjælpe dig med at få din egen unikke låge i komposit.
                </p>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få solid kompositlåge i dag</span>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/komposithegn-laage.webp", "width=1200,quality=85,format=auto")}
                alt="Specialtilpasset kompositlåge og hegn"
                className="w-full h-auto aspect-[16/10] object-cover"
              />
            </div>
          </div>

          {/* Rådgivning sektion */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-12 border border-slate-200/80 mb-16 space-y-4">
            <h3 className="text-2xl font-bold text-slate-900">
              Professionel rådgivning og montering af kompositlåger i hele Danmark
            </h3>
            <p className="text-slate-700 leading-relaxed text-base">
              Når du vælger en speciallavet låge, kan vi også være behjælpelige med lukke systemet, så du får det, der passer bedst til din låge og behov for sikkerhed. Er du i tvivl om, hvad du skal vælge, så kan du altid <Link to="/kontakt" className="text-[#004fa4] font-bold hover:underline">kontakte os</Link> for råd og vejledning.
            </p>
            <p className="text-slate-700 leading-relaxed text-base">
              Vi har mange års erfaring med design og montering af kompositlåger, og vi hjælper kunder i Odense, Aalborg, Silkeborg, Gentofte og resten af det danske land. Uanset hvor du befinder dig, kan vi hjælpe dig.
            </p>
          </div>

          {/* Galleri */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Kompositlåge billeder
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Se fotos af monterede kompositlåger hos tilfredse kunder over hele landet.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-48 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=400,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2 rounded-full bg-[#143463]/90 text-white text-xs">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Pris & kontakt */}
          <div className="border border-slate-200 rounded-2xl p-8 sm:p-10 bg-slate-50 space-y-4">
            <h3 className="text-2xl font-bold text-slate-900">
              Pris på komposithegn med låge
            </h3>
            <p className="text-slate-700 leading-relaxed text-base">
              Når du vælger en kompositlåge hos Hovendals, er lågen altid lavet i tæt dialog med dig, så du får den låge, der passer præcis til dine ønsker og behov. Det er derfor ikke muligt at angive en pris på en låge, da det afhænger af, hvorvidt den er lavet ud fra standardmål, specialmål samt farve og struktur.
            </p>
            <p className="text-slate-700 leading-relaxed text-base">
              Hos Hovendals er vi dog konkurrencedygtige inden for udarbejdelse af kompositlåger, og du kan derfor være sikker på, at vores priser altid er skarpe. Har du brug for en kompositlåge, så er du altid velkommen til at kontakte os på mail, telefon eller ved at udfylde kontaktformularen. Så kan vi tage en snak om dine ønsker til lågen, samt kan vi give et estimat af, hvad din unikke kompositlåge vil koste.
            </p>
            <p className="text-slate-700 leading-relaxed text-base">
              Har du brug for en kompositlåge, så er du altid velkommen til at kontakte os på <a href={`mailto:${companyInfo.email}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.email}</a>, telefon: <a href={`tel:${companyInfo.phoneFormatted}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.phone}</a> eller ved at udfylde kontaktformularen. Så kan vi tage en snak om dine ønsker til lågen, samt kan vi give et estimat af, hvad din unikke komposit låge vil koste.
            </p>
            <div className="flex flex-wrap gap-4 pt-2">
              <a
                href={`tel:${companyInfo.phoneFormatted}`}
                className="px-6 py-2.5 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all"
              >
                Ring os op
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="px-6 py-2.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all"
              >
                Skriv en mail
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
